import { defineMessages } from 'react-intl'

export default defineMessages({
  audiobook: {
    id: 'data.products.audiobook.short',
    defaultMessage: 'Audiobook',
  },
  'audio-guide': {
    id: 'data.products.audio-guide.short',
    defaultMessage: 'Audio guide',
  },
  elearning: {
    id: 'data.products.elearning.short',
    defaultMessage: 'eLearning',
  },
  navigation: {
    id: 'data.products.navigation.short',
    defaultMessage: 'Navigation',
  },
  'video-presentation-product-video': {
    id: 'data.products.video-presentation-product-video.short',
    defaultMessage: 'Product Video',
  },
  technology: {
    id: 'data.products.technology.short',
    defaultMessage: 'Technology',
  },
  'tv-narrator-documentary': {
    id: 'data.products.tv-narrator-documentary.short',
    defaultMessage: 'Narration',
  },
  commercial: {
    id: 'data.products.commercial.short',
    defaultMessage: 'Commercial',
  },
  'television-series': {
    id: 'data.products.television-series.short',
    defaultMessage: 'TV Series',
  },
  movie: {
    id: 'data.products.movie.short',
    defaultMessage: 'Movie',
  },
  'animation-movie': {
    id: 'data.products.animation-movie.short',
    defaultMessage: 'Animation',
  },
  'animation-series': {
    id: 'data.products.animation-series.short',
    defaultMessage: 'Animation',
  },
  'audio-description-ad': {
    id: 'data.products.audio-description-ad.short',
    defaultMessage: 'AD',
  },
  'automated-dialogue-replacement-adr': {
    id: 'data.products.automated-dialogue-replacement-adr.short',
    defaultMessage: 'ADR',
  },
  gaming: {
    id: 'data.products.gaming.short',
    defaultMessage: 'Gaming',
  },
  subtitles: {
    id: 'data.products.subtitles.short',
    defaultMessage: 'Subtitles',
  },
  'event-presentation-internal': {
    id: 'data.products.event-presentation-internal.short',
    defaultMessage: 'Event',
  },
  ivr: {
    id: 'data.products.ivr.short',
    defaultMessage: 'IVR',
  },
  podcast: {
    id: 'data.products.podcast.short',
    defaultMessage: 'Podcast',
  },
  character: {
    id: 'data.products.character.short',
    defaultMessage: 'Character',
  },
})
